<h1 translate
    matDialogTitle>
    job_modal_title
</h1>

<form [formGroup]="form"
      (submit)="onSubmit()">
    <mat-dialog-content [class.overflow-visible]="isTargetJobsCount"
                        class="job-dialog-container">
        <div class="process-list-container">
            <mat-form-field>
                <ui-suggest [placeholder]="'job_modal_form_process' | translate"
                            [disabled]="isInputJobProvided"
                            [defaultValue]="'job_modal_form_process_empty' | translate"
                            [searchSourceFactory]="processSearchFactory"
                            [clearable]="false"
                            [displayCount]="5"
                            [required]="true"
                            data-cy="job-modal-process"
                            (selected)="onProcessSelected($event)"
                            formControlName="releaseKey"
                            class="form-control">
                </ui-suggest>
            </mat-form-field>
        </div>
        <mat-tab-group>
            <mat-tab #executionTargetTab
                     [label]="'job_modal_execution_target_tab' | translate">
            </mat-tab>
            <mat-tab #parameterTab
                     [disabled]="!process">
                <ng-template mat-tab-label>
                    <mat-icon *ngIf="form.get('arguments')!.valid &&
                                    paramCollection.isOpen"
                              class="mat-accent">edit</mat-icon>
                    <mat-icon *ngIf="form.get('arguments')!.invalid"
                              class="mat-warn">warning</mat-icon>
                    {{ 'job_modal_execution_parameters_tab' | translate }}
                </ng-template>
            </mat-tab>
        </mat-tab-group>
        <div [hidden]="!executionTargetTab.isActive"
             class="execution-target">
            <div class="filter-options">
                <mat-radio-group (change)="strategy = $event.value"
                                 formControlName="strategy"
                                 class="layout-row layout-align-h-center">
                    <mat-radio-button [value]="JobStartStrategy.SpecificRobots">
                        {{ 'job_modal_execution_target_specific_robots' | translate }}
                    </mat-radio-button>
                    <mat-radio-button [value]="JobStartStrategy.JobsCount">
                        {{ 'job_modal_execution_target_dynamic_allocation' | translate }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="robot-list-container">
                <ui-process-robots-grid #processRobotsGrid
                                        [isJobsGrid]="true"
                                        [hidden]="!isTargetSpecificRobots"
                                        (selectionChange)="form.updateValueAndValidity()">
                </ui-process-robots-grid>
            </div>
            <div *ngIf="isTargetJobsCount"
                 class="jobsCount">
                <div class="layout-row layout-align-v-start layout-align-h-center">
                    <div class="input-label--before layout-row layout-align-v-start layout-align-h-center">
                        <label translate>dynamic_allocation_execute_process</label>
                    </div>
                    <mat-form-field class="flex-10">
                        <input [attr.max]="maxNoOfJobs"
                               formControlName="jobsCount"
                               matInput
                               uiRestrictInput="^[0-9]+$"
                               min="1"
                               class="form-control"
                               type="text" />
                    </mat-form-field>
                    <div class="input-label--after layout-row layout-align-v-center layout-align-h-center">
                        <label translate>dynamic_allocation_times</label>
                    </div>
                </div>
            </div>
        </div>
        <div [hidden]="!parameterTab.isActive">
            <ui-parameter-collection #paramCollection
                                     [collection]="process?.arguments?.input || []"
                                     [editable]="true"
                                     formControlName="arguments"
                                     type="input">
            </ui-parameter-collection>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions *ngLet="{
        loading: loading$ | async
    } as state"
                        align="end">
        <button mat-dialog-close
                mat-button
                data-cy="cancel"
                type="button">
            {{ 'modal_action_cancel' | translate }}
        </button>
        <button [spinnerButtonLoading]="state.loading"
                [disabled]="state.loading ||
                            form.invalid ||
                            paramCollection.isOpen"
                ui-spinner-button
                mat-flat-button
                type="submit"
                data-cy="submit"
                color="primary">{{ 'job_modal_action_start' | translate }}</button>
    </mat-dialog-actions>
</form>
